import store from '../store'
import router from "../router"

export default {
  namespaced: true,
  state: {
    eventAccess: [],
  },
  mutations: {
    setEventAccess(state, eventId) {
     state.eventAccess.push(eventId)     
    }
  },
  actions: {
    setEventAccess({commit}, eventId) {
      commit('setEventAccess', eventId)
    }
  },
  getters: {
    getEventAccess(state) {
      return state.eventAccess
    }
  }
}
